import { PlanningDayJson } from '../../types/models';
import { CamionNetBaseApiClient } from '../base-client';

/**
 * Planning API Types
 */
export interface GetPlanningParams {
  from: string; // Format: YYYY-MM-DD
  to: string;   // Format: YYYY-MM-DD
}

export type GetPlanningResponse = PlanningDayJson[];

/**
 * Planning API Endpoints
 */
export class PlanningApi extends CamionNetBaseApiClient {
  /**
   * Get planning data between two dates for the authenticated agent
   */
  async getPlanning(params: GetPlanningParams): Promise<GetPlanningResponse> {
    return this.request<GetPlanningResponse>(`/api2/plannings/agent-planning/${params.from}/${params.to}`);
  }
}
